import { Box } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  width?: number;
  minWidth?: number;
};

export const CarouselItem = ({
  children,
  width = 175,
  minWidth = 175,
}: Props) => (
  <Box
    width={width}
    minWidth={minWidth}
    minHeight={44}
    sx={{
      scrollSnapAlign: "start",
      touchAction: "pan-x pan-y",
    }}
  >
    {children}
  </Box>
);
